import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Template } from '../../models/account-models';
import { AccountsService } from '../services/accounts-service.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxLoadingModule } from 'ngx-loading';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-shared-template-modal',
  templateUrl: './shared-template-modal.component.html',
  styleUrls: ['./shared-template-modal.component.scss'],
  imports: [
    MatFormFieldModule,
    NgxLoadingModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    FormsModule,
  ],
})
export class SharedTemplateModalComponent {
  private dialogRef =
    inject<MatDialogRef<SharedTemplateModalComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);
  private as = inject(AccountsService);
  private snacky = inject(MatSnackBar);

  template: Template = {} as Template;
  loading = false;
  templateId = new FormControl();

  saveData() {
    this.loading = true;
    this.as.copyTemplate(this.templateId.value).subscribe({
      next: resp => {
        this.loading = false;
        this.dialogRef.close(resp.results);
        this.dialogRef.afterClosed().subscribe(() => {
          this.dialogRef = null;
        });
      },
      error: () => {
        this.loading = false;
        this.snacky.open(
          `An unexpected error occurred with this template ID. Please try again or enter a different ID.`,
          'Close',
          {
            duration: 15000,
          }
        );
      },
    });
  }

  close() {
    this.dialogRef.close();
    this.dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }
}
